import { render, staticRenderFns } from "./WeMedia.vue?vue&type=template&id=7980d55e&scoped=true"
import script from "./WeMedia.vue?vue&type=script&lang=js"
export * from "./WeMedia.vue?vue&type=script&lang=js"
import style0 from "./WeMedia.vue?vue&type=style&index=0&id=7980d55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980d55e",
  null
  
)

export default component.exports